// extracted by mini-css-extract-plugin
module.exports = {"RoundCards":"History_RoundCards__3KZft"};